import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import CircularProgress from '@mui/material/CircularProgress';
import { isShipmentUnderReview } from 'src/utils/invoiceStatus';
import { useUserContext } from 'src/use-cases/user/userDetails';
import IconTick from 'src/assets/images/icons/tick-circle-neutral.svg';
import Thumbnail from 'src/assets/images/under-construction.svg';

import { useShipmentSelector } from '../../ShipmentSelector';
import { SelectedDeviationProvider } from './SelectedDeviationContext';
import { ProcurementDeviationsMain } from './Main';
import { UCTDeviationsProps } from './types';

export const MainDetailsDeviations: FC<UCTDeviationsProps> = (props) => {
  const { invoiceSummary } = props;
  const { shipment, isLoadingShipment } = useShipmentSelector();
  const [searchParams] = useSearchParams();
  const userDetails = useUserContext();

  // Show loading while data is being fetched
  if (isLoadingShipment || !invoiceSummary) {
    return (
      <div className='flex items-center justify-center flex-1'>
        <CircularProgress size={40} />
      </div>
    );
  }

  const isFromInternal = searchParams.get('ref') === 'internal';
  let isUnderReview = isShipmentUnderReview(invoiceSummary, shipment?.shipmentInvoiceId);
  if (isUnderReview && userDetails?.isSystemAdmin && isFromInternal) {
    isUnderReview = false;
  }

  // Priority check: If shipment is under review, show under review message regardless of deviation count
  if (isUnderReview) {
    return (
      <div className='w-full h-full p-24 flex items-center justify-center gap-12'>
        <div className='flex flex-col items-center justify-center'>
          <span>
            <img src={Thumbnail} alt='' className='w-[120px]' />
          </span>
          <h2 className='text-24 font-bold text-neutral-90 mt-32'>Under Review</h2>
          <p className='text-14 flex-regular text-neutral-70'>This shipment is under review by Freya and the support team.</p>
        </div>
      </div>
    );
  }

  // Only show "no deviations" if NOT under review
  if (!shipment?.deviations || shipment.deviations.length < 1) {
    return (
      <div className='flex items-center justify-center flex-1'>
        <div className='flex flex-col items-center justify-center gap-12'>
          <img src={IconTick} alt='' className='w-40 xl:w-60' />
          <p className='text-14 xl:text-16 text-blue_grey-30'>No deviations detected</p>
        </div>
      </div>
    );
  }

  return (
    <div className='flex-1 overflow-y-scroll'>
      <div className='flex flex-col h-full'>
        <SelectedDeviationProvider>
          <ProcurementDeviationsMain invoiceSummary={invoiceSummary} shipmentInvoiceId={shipment?.shipmentInvoiceId} />
        </SelectedDeviationProvider>
      </div>
    </div>
  );
};
